import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DatePicker, { registerLocale } from 'react-datepicker';
import { format, parseISO } from 'date-fns';
import { el } from 'date-fns/locale';

import "react-datepicker/dist/react-datepicker.css";
registerLocale('el', el);

class DateInput extends Component {

	constructor(props) {
		super(props);
		let value = (props.value && props.value !== '') ? parseISO(props.value) : '';
		this.state = {
			value,
		}

		this.handleChange = this.handleChange.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value)
			this.setState({
				value: parseISO(this.props.value),
			});
	}

	handleChange = (value) => {
		this.setState({value});
		this.props.onChange({target: {name: this.props.name, value: format(value, 'yyyy-MM-dd')}});
	}

	render() {

		const { value, ...otherProps } = this.props;

		return (
			<DatePicker
				{...otherProps}
				locale="el"
				selected={this.state.value}
				onChange={this.handleChange}
				allowSameDay={true}
				showTimeSelect={false}
				dateFormat="d MMMM yyyy"
				className="form-control"
			/>
		);
	}
}

DateInput.propTypes = {
	value: PropTypes.string,
	name: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
};

export default DateInput;
